// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__2njQm","innerContainer":"style_innerContainer__6nZod","middlePane":"style_middlePane__2A-9z","copyRight":"style_copyRight__3yRiM"};